import "../styles/HomeNew.css";

const STEPS = [
  { label: "Log into Your Bank Account", desc: "Sign in to your online banking or mobile banking app where you have Zelle available.", emoji: "🏦" },
  { label: "Select 'Send Money'", desc: "Locate the option to send money using Zelle within your banking app.", emoji: "📲" },
  { label: "Enter Our Zelle Email", desc: "For the recipient, enter our Zelle email address: donate@forbettertomorrow.org", emoji: "✉️", highlight: "donate@forbettertomorrow.org" },
  { label: "Specify the Amount", desc: "Enter the amount you wish to donate.", emoji: "💵" },
  { label: "Include a Note (Optional)", desc: "If you'd like to provide any specific information or designations for your donation, feel free to include a note.", emoji: "📝" },
  { label: "Confirm and Send", desc: "Double-check the details and, when you're ready, confirm the transaction. Your donation goes straight to FBT with zero processing fees.", emoji: "✅" },
];

export default function DonateZelle() {
  return (
    <div className="pg">

      {/* ── HERO ── */}
      <section className="hero" style={{ minHeight: "44svh" }}>
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr auto" }}>
          <div className="hero__text">
            <p className="hero__kicker">Zero Processing Fees</p>
            <h1 className="hero__h1">
              Donate via<br />
              <span className="hero__accent">Zelle</span>
            </h1>
            <p className="hero__sub">
              One of the best ways to support FBT. With Zelle, every single dollar
              you contribute goes directly to our mission — no fees, no deductions.
            </p>
            <div className="hero__ctas">
              <a href="/donate" className="cta cta--solid">Other Ways to Donate</a>
            </div>
          </div>
          <div className="hero__stats">
            <div className="hstat hstat--purple">
              <span className="hstat__n">100%</span>
              <span className="hstat__l">Reaches FBT</span>
            </div>
            <div className="hstat hstat--green">
              <span className="hstat__n">$0</span>
              <span className="hstat__l">Processing Fees</span>
            </div>
            <div className="hstat hstat--pink">
              <span className="hstat__n">100%</span>
              <span className="hstat__l">Tax Deductible</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── STEPS ── */}
      <section className="local" style={{ maxWidth: "800px", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Step by Step</span>
          <h2 className="sec-h2">How to Donate via Zelle</h2>
          <p className="sec-sub">It only takes a minute and 100% of your donation goes directly to supporting our programs.</p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: ".75rem" }}>
          {STEPS.map((step, i) => (
            <div key={i} className="lcard" style={{ flexDirection: "row", gap: "1.1rem", alignItems: "flex-start" }}>
              {/* Number circle */}
              <div style={{
                flexShrink: 0,
                width: 44, height: 44,
                borderRadius: "50%",
                background: i % 3 === 0 ? "var(--pu-100)" : i % 3 === 1 ? "var(--pk-100)" : "var(--gn-100)",
                color: i % 3 === 0 ? "var(--pu-700)" : i % 3 === 1 ? "var(--pk-700)" : "var(--gn-700)",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontFamily: "var(--ff-head)", fontWeight: 800, fontSize: "1rem",
              }}>
                {i + 1}
              </div>
              <div style={{ flex: 1 }}>
                <h4 style={{
                  fontFamily: "var(--ff-head)",
                  fontSize: ".97rem",
                  fontWeight: 800,
                  color: "var(--ink)",
                  marginBottom: ".3rem",
                }}>
                  {step.label}
                </h4>
                <p style={{ fontSize: ".87rem", color: "var(--muted)", lineHeight: 1.7 }}>
                  {step.highlight
                    ? step.desc.split(step.highlight).map((part, j, arr) => (
                      j < arr.length - 1
                        ? <span key={j}>{part}<strong style={{ color: "var(--pu-700)", background: "var(--pu-50)", borderRadius: "4px", padding: "0 .3em" }}>{step.highlight}</strong></span>
                        : <span key={j}>{part}</span>
                    ))
                    : step.desc
                  }
                </p>
              </div>
              <span style={{ fontSize: "1.6rem", flexShrink: 0 }}>{step.emoji}</span>
            </div>
          ))}
        </div>

        {/* Tax deductible note */}
        <div className="lcard" style={{ marginTop: "1rem", background: "var(--pu-50)", borderColor: "var(--pu-200)", flexDirection: "row", gap: "1rem", alignItems: "center" }}>
          <span style={{ fontSize: "1.5rem" }}>📄</span>
          <p style={{ fontSize: ".88rem", color: "var(--muted)", lineHeight: 1.7 }}>
            All donations are{" "}
            <a
              href="https://forbettertomorrow.org/wp-content/uploads/2018/05/FBT-501C3.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "var(--pu-500)", fontWeight: 700 }}
            >
              100% tax deductible ↗
            </a>
            . Your generous contribution through Zelle ensures that 100% of your
            donation directly supports our programs and initiatives.
          </p>
        </div>
      </section>

      {/* ── QR INSTRUCTIONS ── */}
      <section className="local" style={{ maxWidth: "500px", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Visual Guide</span>
          <h2 className="sec-h2">Zelle Instructions</h2>
        </div>
        <div className="lcard" style={{ alignItems: "center", padding: "2rem" }}>
          <img
            src="/images/base/Zelle_Instructions.png"
            alt="Zelle donation instructions"
            style={{ maxWidth: "300px", width: "100%", borderRadius: "12px", display: "block" }}
          />
        </div>
      </section>

      {/* ── QUOTE BAND ── */}
      <div className="quote-band">
        <p>A heartfelt thank you to all our supporters!</p>
      </div>

    </div>
  );
}